import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Chicago needed",
      "Ideal for UIowa faculty with international conferences",
      "Perfect for Iowa River Landing business travelers",
      "Great for Johnson County families with upcoming vacations",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Coralville or Iowa City post offices",
      "Good for planned international trips from CID",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Coralville or Iowa City USPS",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Chicago — ~240 mi, 4 hrs drive",
      "NPIC appointment required before traveling to Chicago",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function CoralvilleProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Coralville"
      introText="Coralville residents — University of Iowa faculty traveling to international conferences, Iowa River Landing business professionals with global meetings, and Johnson County families planning summer trips abroad — have several options for getting a passport fast. Here is how they compare, and why most Coralville residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the 4-hour drive to Chicago."
      options={options}
      emergencyDescription="Coralville does not have its own regional passport agency. The closest is Chicago — about 240 miles east on I-80, typically 4 hours of driving each way. For a UIowa researcher with a last-minute conference presentation in Geneva or an Iowa River Landing executive flying to London next week, that 8-hour round trip is simply not feasible. Most eastern Iowa travelers find courier service to be the only practical option."
      disclaimerText="*Processing speed depends on eligibility and documentation. Coralville does not have a regional passport agency — the closest is Chicago (4 hours away). Not all applicants qualify for Regional Agency Processing."
    />
  );
}